//#region Styles
import {
    Container, HeaderCell, 
    Table, THead, TFoot } from "./styles";
//#endregion

const SimpleTableList = ({
    headers, content,
    footer, width, maxHeight, 
    tableWidth = {}
}) => {
    return (
        <Container 
            className="custom-scrollbar primary"
            width={width}
            maxHeight={maxHeight}>
            <Table {...tableWidth}>
                <THead>
                    <tr>
                        {headers.map(({
                            icon,
                            title,
                            styleProps = {}
                        }, idx) => (
                            <th key={idx}>
                                <HeaderCell {...styleProps}>
                                    {icon}
                                    <span>{title}</span>
                                </HeaderCell>
                            </th>
                        ))}
                    </tr>
                </THead>
                <tbody>
                    {content}
                </tbody>
                {footer && 
                <TFoot>
                    {footer}
                </TFoot>}
            </Table>
        </Container>
    );
}

export default SimpleTableList;